var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFFAE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9106 10.9665C17.7088 9.81162 17.173 8.74119 16.3696 7.88744C15.5661 7.0337 14.5301 6.43405 13.3896 6.16258C12.2491 5.89111 11.054 5.95972 9.95205 6.35993C8.8501 6.76014 7.88954 7.47441 7.18904 8.4145C6.48854 9.35459 6.07881 10.4793 6.01045 11.6497C5.9421 12.8201 6.21812 13.9848 6.80442 15.0001C7.39072 16.0153 8.2616 16.8366 9.30947 17.3623C10.3573 17.8881 11.5363 18.0953 12.7006 17.9585",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.6665V11.9998L13 12.9998",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 14H16.3333C16.068 14 15.8137 14.1054 15.6261 14.2929C15.4386 14.4804 15.3333 14.7348 15.3333 15C15.3333 15.2652 15.4386 15.5196 15.6261 15.7071C15.8137 15.8946 16.068 16 16.3333 16H16.9999C17.2651 16 17.5195 16.1054 17.707 16.2929C17.8946 16.4804 17.9999 16.7348 17.9999 17C17.9999 17.2652 17.8946 17.5196 17.707 17.7071C17.5195 17.8946 17.2651 18 16.9999 18H15.3333",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.0002V18.6668M16.6667 13.3335V14.0002",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPending);
export default __webpack_public_path__ + "static/media/payment_pending.9d10f3582513b198cf992499fc09b0e4.svg";
export { ForwardRef as ReactComponent };